import actions from './actions';


const initialState = {
    movsCajaAux: [],
    loadingMovsAux: false,
    loadedMovsAux: false,
    paginationMovsInfo: {},
    startDate: null,
    endDate: null,
    loadingInformesMovAux: false,
    dataInformesMoxAux: {},
};


export default function cajaReducer(state = initialState, action) {
    switch (action.type) {

        case actions.GET_MOV_AUX:
            return {
                ...state,
                loadedMovsAux: false,
                loadingMovsAux: true,
            }
        case actions.UPDATE_MOVS_AUX:
            return {
                ...state,
                movsCajaAux: action.payload,
                loadedMovsAux: true,
                loadingMovsAux: false,
            }
        case actions.SET_PAGINATION_MOVS_INFO:
            return {
                ...state,
                paginationMovsInfo: action.payload,
            };
        case actions.UPDATE_MOV_AUX_SUCCESS:
            return {
                ...state,
                movsCajaAux: state.movsCajaAux.map(mov => mov._id === action.payload._id ? action.payload : mov)
            };
        case actions.GET_INFORMES_MOV_AUX_REQUEST:
            return {
                ...state,
                loadingInformesMovAux: true
            };
        case actions.GET_INFORMES_MOV_AUX_SUCCESS:
            return {
                ...state,
                loadingInformesMovAux: false,
                dataInformesMoxAux: action.payload
            };
        default:
            return state;
    }

}
